import { memo } from 'react';

import clsx from 'clsx';

import { Date, dateWidgetClasses, DateWidgetVariant, Day, Month, Props, Root, variants } from './styles';
import useDateWidgetVM from './vm';

export { variants };
export type { DateWidgetVariant };

const DateWidget = ({ variant = 'unpublished', className, classes, ...vmOptions }: Props) => {
  const { dateNum, dayName, monthName } = useDateWidgetVM(vmOptions);

  return (
    <Root className={clsx(className, dateWidgetClasses[variant], classes?.root, classes?.[variant])}>
      <Month className={clsx(dateWidgetClasses.month, classes?.month)}>{monthName}</Month>
      <Date className={clsx(dateWidgetClasses.date, classes?.date)}>{dateNum}</Date>
      <Day className={clsx(dateWidgetClasses.day, classes?.day)}>{dayName}</Day>
    </Root>
  );
};

export default memo(DateWidget);
